import { render, staticRenderFns } from "./TableInvDistributors.vue?vue&type=template&id=4d71bbf9&scoped=true"
import script from "./TableInvDistributors.vue?vue&type=script&lang=js"
export * from "./TableInvDistributors.vue?vue&type=script&lang=js"
import style0 from "./TableInvDistributors.vue?vue&type=style&index=0&id=4d71bbf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d71bbf9",
  null
  
)

export default component.exports